import { Autocomplete, Grid, TextField } from "@mui/material";
import { AloveSwitch } from "components/alove/AloveSwitch";
import { Batch } from "models/batch/Batch";
import { Attribute } from "models/profile/Attribute";
import { useEffect, useState } from "react";
import { camelCaseToCapitalizedWords } from "utils/globalsUtils";
import { getQuestionnairesNames, questionnarieListDo } from "utils/questionsUtils";

export const AttributeSettings = ({
  attribute,
  setAttribute,
}: {
  attribute: Attribute;
  setAttribute: any;
}) => {
  const [questionnaires, setQuestionnaires] = useState({} as { [key: string]: number });
  useEffect(() => {
    getQuestionnairesNames().then((res) => {
      setQuestionnaires(res);
    });
  }, []);

  return (
    <Grid container>
      <Grid
        size={{
          xs: 12,
          md: 6
        }}>
        <AloveSwitch
          title="Filter By Deal Breaker"
          subtitle="Can used to filter matches by deal breaker status."
          value={attribute.settings?.filterByDealBreaker}
          setValue={(value: boolean) =>
            setAttribute({
              ...attribute,
              settings: { ...attribute.settings, filterByDealBreaker: value },
            })
          }
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6
        }}>
        <Autocomplete
          options={Object.values(questionnaires)}
          getOptionLabel={(option: number) =>
            camelCaseToCapitalizedWords(
              Object.entries(questionnaires).find(([key, value]) => value == option)?.[0] || ""
            )
          }
          value={attribute.relatedBatchId || null}
          onChange={(event, newValue) => {
            setAttribute({ ...attribute, relatedBatchId: newValue });
          }}
          renderInput={(params) => <TextField {...params} label="Related Batch" />}
        />
      </Grid>
    </Grid>
  );
};
